import React, { useEffect, useState } from 'react';
import { fetchLogTContentById } from '../services/logTContentService'; // Import the action
import Loader from '../components/LoadingSpinner'; // Import your Loader component
import { ILogt } from '../models/logT';
import { ILogTContent } from '../models/logTContent';
import '../styles/MessageDetails.scss';
import { useAuth } from '../context/AuthContext'; 
interface MessageDetailsProps {
  logT: ILogt | null; // No need for `any`
  onClose?: () => void; // Add optional close handler
}

const MessageDetails: React.FC<MessageDetailsProps> = ({ logT, onClose }) => {
  const [logTContent, setLogTContent] = useState<ILogTContent | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [wrapText, setWrapText] = useState(true);
  const userGroups = useAuth();
  const accessToken = userGroups?.userData?.access_token || '';

  useEffect(() => { 
    if (!logT?.logtId) return; // ✅ Prevents unnecessary API calls

    const fetchLogTContent = async () => {
      setIsLoading(true);
      try {
        const content = await fetchLogTContentById(logT.logtId ?? 0, accessToken);
        setLogTContent(content);
      } catch (error) {
        console.error("Error fetching logT content:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchLogTContent();
  }, [logT?.logtId, accessToken]);

  if (!logT) {
    return <div>No Message Selected</div>;
  }

  if (isLoading) {
    return (
      <div className="message-details-container">
        <div className="message-details-loader">
          <Loader size="large" />
        </div>
      </div>
    );
  }

  return (
    <div className="message-details-container">
      <div className="message-details-header">
        <label className="toggle-wrapper">
          <input
            type="checkbox"
            checked={wrapText}
            onChange={(e) => {
              setWrapText(!wrapText);
            }}
            aria-label="Toggle text wrapping"
          />
          <span 
            className="toggle-switch"
            role="switch"
            aria-checked={wrapText}
            aria-label="Text wrap toggle"
          >
            <span className="toggle-slider">
              <span className="toggle-knob"></span>
            </span>
          </span>
          <span className="toggle-label">
            {wrapText ? 'Wrap ON' : 'Wrap OFF'}
          </span>
        </label>
        <h2 className="message-details-title">Message Details</h2>
        {onClose && (
          <button className="close-button" onClick={onClose} aria-label="Close">
            ×
          </button>
        )}
      </div>
      <div className="message-content">
        {logTContent ? (
          wrapText ? (
            <pre className="message-pre">{logTContent.msg}</pre>
          ) : (
            <p className="message-text">{logTContent.msg}</p>
          )
        ) : (
          <p className="no-content">No content available.</p>
        )}
      </div>
    </div>
  );
};

export default MessageDetails;
